import { atom } from 'jotai';

export const notificationsArchivedBeforeAtom = atom<number | null>(null);
